// Cybersource funding response constants
export const CYBERSOURCE_SUCCESS_REASON_CODE = '100'
export const CYBERSOURCE_SALE_TRANSACTION = 'SALE'
